export const urlMap = {
    noProject: () => {
        return window.location.pathname?.includes('/saas/noProject')
    },
    guidePage: () => {
        return window.location.pathname?.includes('/saas/guidePage')
    },
    nosubScribe: () => {
        return window.location.pathname?.includes('/home/nosubScribe')
    },
    nofunc: () => {
        return window.location.pathname?.includes('/home/nofunc')
    },
    loginHtml: () => {
        return window.location.pathname?.includes('/loginHtml')
    },
}